export const Props = () => ({
  //--------------------------------------------------------------------------
  //               Определяем, в какой тег будет оборачиваться Wrapper
  //--------------------------------------------------------------------------
  tag: {
    type: String,
    default: 'div',
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                    Класс модификатор от родительского тега
  //----------------------------------------------------------------------------
  className: {
    type: String,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});
